import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import helper from './helper'

Vue.config.productionTip = false
global.helper = helper

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  created () {
    this.$store.dispatch('initBackend')
  }
}).$mount('#app')
